import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import qs from 'query-string';

import { Processing } from '../components/processing';
import { PATHS } from '../configs';
import client from '../services/client';
import { useInvoice } from '../services/use-invoice';
import { useAppContext } from '../stores/app-context';

export const AuthTaiwanPay = () => {
  const { invoiceId } = useParams();
  const isInvoiceIdValid = typeof invoiceId === 'string';
  const navigate = useNavigate();
  const confirmedRef = useRef(false);

  const { onToastError } = useAppContext();

  const { refetch } = useInvoice(
    { invoiceId },
    {
      enabled: isInvoiceIdValid,
    },
  );

  const hashData = qs.parse(window.location.hash);

  const { merchant_transaction_id } = hashData as {
    merchant_transaction_id: string;
  };

  useEffect(() => {
    if (confirmedRef.current) {
      return;
    }

    const confirm = async () => {
      confirmedRef.current = true;

      try {
        // 即使 invoice 狀態為 paid，仍需呼叫 confirm API
        // 確保供應商端的授權狀態有被正確設定
        await client.confirmTaiwanPayTransaction({
          transactionId: merchant_transaction_id,
        });
      } catch (err) {
        onToastError(err.message);
      } finally {
        await refetch();
        // confirm 完成後導回 invoice 頁面，由 Invoices 元件處理後續導向
        navigate(PATHS.INVOICES(invoiceId)['']);
      }
    };

    confirm();
  }, [merchant_transaction_id, invoiceId, refetch, onToastError, navigate]);

  return <Processing />;
};
